"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the E-book landing page. Modern styles cite an
 * e-book like a print book (APA 7 dropped the platform/format requirement), so the tool
 * opens on the manual-entry tab preset to the CSL `book` type. Users add a DOI or URL
 * only when the e-book came from a database — no engine change.
 */
export default function EbookCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="book"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
